import React, { useState } from 'react';
import styles from './Textarea.module.scss';
import { TextareaProps } from './Textarea.types';

const className = 'textfield';

const Textarea: React.FC<TextareaProps> = ({
  className: classNameProps,
  name,
  iconLeft,
  iconRight,
  label,
  onChange,
  placeholder,
  value,
  disabled = false,
}) => {

  return (
    <>
      {label && <label className={styles[className + '__label']}>
        {label}  
      </label>}
      <div className={[styles[`${className}`], classNameProps,
        disabled ? styles[`${className}__disabled`] : ''].join(' ')}>
        {iconLeft && (
          <span className={styles[`${className}__icon_left`]}>
            {iconLeft}
          </span>
        )}
        <textarea
          className={styles[`${className}__input`]}
          data-testid="input-textfield"
          disabled={disabled}
          name={name}
          onChange={(e) => onChange && onChange(e)}
          placeholder={placeholder}
          style={{ flex: 1 }}
          value={value}
        />
        {
          iconRight
        }
      </div>
    </>
  );
};

export default React.memo(Textarea);